fx.ns("models", class ThemeTag extends fx.Model {

	constructor(data)
	{
		super(data);
	}
	

	get name()
	{
		return this.tag;
	}

});